import { render, staticRenderFns } from "./StatsDialog.vue?vue&type=template&id=d7a77332"
import script from "./StatsDialog.vue?vue&type=script&lang=js"
export * from "./StatsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports